import { render, staticRenderFns } from "./AddWarehousePage.vue?vue&type=template&id=25c9ba76"
import script from "./AddWarehousePage.vue?vue&type=script&lang=js"
export * from "./AddWarehousePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports